import React, { createContext, useState } from "react";

const ModalContext = createContext();

const ModalProvider = ({ children }) => {
	const [open, setOpen] = useState();

	const handleOpenModal = () => {
		setOpen(!open);
	};

	return (
		<ModalContext.Provider value={{ open, handleOpenModal }}>
			{children}
		</ModalContext.Provider>
	);
};

export { ModalContext, ModalProvider };
